import { render, staticRenderFns } from "./order_pay.vue?vue&type=template&id=2400df90&scoped=true&"
import script from "./order_pay.vue?vue&type=script&lang=js&"
export * from "./order_pay.vue?vue&type=script&lang=js&"
import style0 from "./order_pay.vue?vue&type=style&index=0&id=2400df90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2400df90",
  null
  
)

export default component.exports